/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlayerViewMode {
    HomeScreenVideoWindow = 'HomeScreenVideoWindow',
    FullScreen = 'FullScreen',
    Hidden = 'Hidden', // PIG hidden on HomeScreen — player stopped
    VideoWindow = 'VideoWindow',
}
